module.exports = __webpack_public_path__ + "static/img/c2.55974ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slwh/c2.png
// module id = +ZI2
// module chunks = 0